import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ImageNext"
});
const _hoisted_1 = {
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-724.000000, -20.000000)"><g transform="translate(620.000000, 20.000000)"><g transform="translate(104.000000, 0.000000)"><rect fill="#2C364E" x="0" y="0" width="40" height="40" rx="20"></rect><g transform="translate(13.000000, 13.500000)" fill="#BDC3CD"><path d="M8.47575011,12.8390615 L13.8740735,6.82963974 C14.0419706,6.64273636 14.0419761,6.35770334 13.8740862,6.17079334 L8.47581069,0.160952656 C8.29561339,-0.0396590182 7.98845689,-0.0548023007 7.78975746,0.127129188 L7.75617989,0.161037853 L7.01041616,0.991679792 C6.8426322,1.17855988 6.84263325,1.46346547 7.01041858,1.6503443 L10.2655634,5.27591539 L0.485690918,5.27424492 C0.247255653,5.27413046 0.0489204603,5.44755521 0.00775774601,5.67630182 L0,5.76452708 L0,7.23562245 C0,7.50642935 0.217465377,7.72596738 0.485690924,7.72602413 L10.2655634,7.72676027 L7.01060536,11.3501072 C6.8427049,11.5370102 6.84269788,11.8220459 7.01058913,12.0089574 L7.75620857,12.8390473 C7.93640588,13.039659 8.24356237,13.0548023 8.4422618,12.8728708 L8.47575011,12.8390615 Z"></path></g></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var imageNext = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { imageNext as default };
